import { useFormikContext } from "formik";
import { LabeledInput } from "../../../Components/ConfigurationTab/LabeledInput";
import { ConfigTabState } from "../types";
import { PriceField } from "./priceField";
import { SETTINGS_LABEL_PLACEMENT } from "./constants";

const LABEL = "Reference price";

export const ReferencePriceField = (props: { editing: boolean }) => {
  const { values } = useFormikContext<ConfigTabState>();

  if (!props.editing) {
    return (
      <PriceField
        name="reference_price"
        label={LABEL}
        placeholder="Ref. price"
      />
    );
  }

  return (
    <LabeledInput
      label={LABEL}
      labelPlacement={SETTINGS_LABEL_PLACEMENT}
      type="text"
      name="reference_price"
      disabled
      // Short enough to survive a grid cell; the disabled styling already says
      // it cannot be edited.
      value={`${values.reference_price ?? ""} (fixed)`}
      autoComplete="off"
    />
  );
};
